import { render, staticRenderFns } from "./CustomReveal.vue?vue&type=template&id=35886293&"
import script from "./CustomReveal.vue?vue&type=script&lang=js&"
export * from "./CustomReveal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports